import { Button } from '@servicetitan/design-system';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  padding-left: 6px;
  padding-right: 6px;
  margin-right: 10px;
  margin-left: -6px;

  & .Button__icon--right {
    font-size: 1rem;
    padding-left: 0;
  }

  &.Button--selected,
  &:active,
  &:hover,
  &:focus,
  &:focus:active {
    color: var(--colorsSurfaceDefault);
  }
`;

type ActivityDotProps = {
  $errors: boolean;
};

export const ActivityDot = styled.div<ActivityDotProps>`
  float: right;
  margin-top: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $errors }) => ($errors ? 'red' : 'transparent')};
  border: 1px solid ${({ $errors }) => ($errors ? 'red' : 'transparent')};
`;

export const UserName = styled.div`
  color: #bbb;
  display: inline-block;
  margin-left: 0.5rem;
`;
